import { Box, Button, Typography } from '@mui/material'
import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import invoiceLogo from "./assets/InvoiceLogo.png"
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
  } from '@mui/material';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

const PdfGenerate = forwardRef((props, ref) => {

    console.log(props)
    const data = useSelector((state) => state.AdminData.admin)
    useImperativeHandle(ref, () => ({
        generatePDFs,
      }));

    const generatePDFs = async () => {
        // await setIsGeneratingPDF(true); // Enable PDF mode
        await new Promise((resolve) => setTimeout(resolve, 0)); // Wait for DOM to update
    
         // Logs state during generation
    
        // Create a single jsPDF instance
        const pdf = new jsPDF();
    
        // Component One
        const componentOne = document.getElementById("invoice-pdf");
        const canvasOne = await html2canvas(componentOne, {
          scale: 2,
          useCORS: true,
        });
        const imgDataOne = canvasOne.toDataURL("image/png");
        pdf.addImage(
          imgDataOne,
          "PNG",
          0,
          0,
          210,
          (canvasOne.height * 210) / canvasOne.width
        );
        pdf.save("invoice.pdf")
      };


  return (
    <Box id="invoice-pdf" sx={{padding : 2, width : '595px', height : '842px', zIndex : '-10000000', display : 'absolute', top : '-100000px'}}>
            <Box sx={{ display : 'flex', justifyContent : 'space-between'}}>
                <Box sx={{display : 'flex', gap : 2}}>
                    <Box sx={{width : '164.71px', height : '92px'}} component={'img'} src={invoiceLogo}></Box>
                    <Box sx={{display : 'flex', justifyContent : 'space-between', flexDirection : 'column', mt : '-13px'}}>
                            <Typography sx={{fontSize : '18px', fontWeight : 600, color : '#27BAC4'}}>{props?.data?.header1?.line1}</Typography>
                            <Typography sx={{fontSize : '18px', fontWeight : 600, color : '#27BAC4'}}>{props?.data?.header1?.line2}</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#5E6470'}}>{props?.data?.header1?.line3}</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#5E6470'}}>{props?.data?.header1?.line4}</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#5E6470'}}>{props?.data?.header1?.line5}</Typography>
                    </Box>
                </Box>
                <Box sx={{display : 'flex', justifyContent : 'flex-end', alignItems : 'end', height : '92px'}}>
                    <Box sx={{display : 'flex', justifyContent : 'space-between', flexDirection : 'column'}}>
                        <Typography sx={{fontSize : '12px', fontWeight : 400, color : '#5E6470'}}>{props?.data?.header2?.line1}</Typography>
                        <Typography sx={{fontSize : '12px', fontWeight : 400, color : '#5E6470'}}>{props?.data?.header2?.line2}</Typography>
                        <Typography sx={{fontSize : '12px', fontWeight : 400, color : '#5E6470'}}>{props?.data?.header2?.line3}</Typography>
                        <Typography sx={{fontSize : '12px', fontWeight : 600, color : '#5E6470'}}>{props?.data?.header2?.line4}</Typography>
                    </Box>
                </Box>
            </Box>

            <Box sx={{mt : 2, border : '1px solid #D7DAE0', borderRadius : '12px', width : '563px', height : '644px', p : 2}}>
                    <Box sx={{display :'flex', justifyContent : 'space-between'}}>
                        <Box>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#5E6470'}}>Billed to</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#1A1C21'}}>{data?.name}</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#5E6470', mt : 2}}>Email Address</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#1A1C21'}}>{data?.userName}</Typography>
                            {/* <Typography sx={{fontSize : '10px', fontWeight : 400, color : '#5E6470'}}>+0 000 000 000 000</Typography> */}
                        </Box>
                        <Box sx={{display : 'flex', flexDirection : 'column'}}>
                            <Box>
                                <Typography sx={{color :'#5E6470', fontSize : '10px'}}>Invoice Number</Typography>
                                <Typography sx={{color :'#1A1C21', fontWeight : 600, fontSize : '10px'}}>{props?.invoiceNumber}</Typography>
                            </Box>
                            <Box sx={{mt : 2}}>
                                <Typography sx={{color :'#5E6470',fontSize :'10px'}}>Invoice Date</Typography>
                                <Typography sx={{color :'#1A1C21', fontWeight : 600, fontSize : '10px'}}>{dayjs(props?.invoiceDate).format("DD MMM, YYYY")}</Typography>
                            </Box>
                        </Box>
                        <Box sx={{display :'flex', alignItems : 'end', flexDirection : 'column'}}>
                            <Typography sx={{color : '#5E6470', fontSize : '10px'}}>Invoice (SGD)</Typography>
                            <Typography sx={{color :'#27BAC4', fontSize : '20px', fontWeight : 700}}>S$ {props?.invoiceAmount/100}</Typography>
                        </Box>
                    </Box>

                    <Box sx={{mt : 3.5, display : 'flex', justifyContent : 'space-between'}}>
                        {/* <Box>
                            <Typography sx={{color : '#5E6470', fontSize : '10px'}}>Subject</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 600}}>{props?.subject}</Typography>
                        </Box> */}
                        {/* <Box sx={{display : 'flex', alignItems : 'end', flexDirection : 'column'}}>
                            <Typography sx={{color : '#5E6470', fontSize : '10px'}}>Due date</Typography>
                            <Typography sx={{fontSize : '10px', fontWeight : 600}}>15 Aug, 2025</Typography>
                        </Box> */}
                    </Box>

                    <Box sx={{mt : 2}}>
                    <TableContainer component={Paper} sx={{border : '1px solid #D7DAE0'}}>
                        <Table sx={{border : '1px solid #D7DAE0'}}>
                            <TableHead sx={{border : '1px solid #D7DAE0'}}>
                            <TableRow sx={{height : '20px', border : '1px solid #D7DAE0'}}>
                                <TableCell sx={{fontSize : '10px', color : '#5E6470', height : '20px', p : '3px', border : '1px solid #D7DAE0'}}><strong>Item Name</strong></TableCell>
                                <TableCell sx={{fontSize : '10px', color : '#5E6470', p : '3px', border : '1px solid #D7DAE0'}}><strong>Qty</strong></TableCell>
                                <TableCell sx={{fontSize : '10px', color : '#5E6470', p : '3px', border : '1px solid #D7DAE0'}}><strong>Rate</strong></TableCell>
                                <TableCell sx={{fontSize : '10px', color : '#5E6470', p : '3px', border : '1px solid #D7DAE0'}}><strong>Amount</strong></TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {/* Sample row, replace with dynamic rows */}
                            <TableRow>
                                <TableCell sx={{fontSize : '10px',p : '5px', border : '1px solid #D7DAE0'}}>{props?.subject}</TableCell>
                                <TableCell sx={{fontSize : '10px',p : '5px', border : '1px solid #D7DAE0'}}>1</TableCell>
                                <TableCell sx={{fontSize : '10px',p : '5px', border : '1px solid #D7DAE0'}}>S$ {props?.invoiceAmount/100}</TableCell>
                                <TableCell sx={{fontSize : '10px',p : '5px', border : '1px solid #D7DAE0'}}>S$ {props?.invoiceAmount/100}</TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{mt : 2.5, display : 'flex', justifyContent : 'space-between', }}>
                            <Box></Box>
                            <Box>
                                <Typography sx={{fontSize : '10px', color : '#1A1C21', fontWeight : 500}}>Subtotal</Typography>
                            </Box>
                            <Box>
                            <Typography sx={{fontSize : '10px', color : '#1A1C21', fontWeight : 500}}>S$ {props?.invoiceAmount/100}</Typography>
                            </Box>
                    </Box>

                    <Box sx={{mt : 2.5, display : 'flex', justifyContent : 'space-between', }}>
                            <Box></Box>
                            <Box>
                                <Typography sx={{fontSize : '10px', color : '#1A1C21', fontWeight : 700}}>Total</Typography>
                            </Box>
                            <Box>
                            <Typography sx={{fontSize : '10px', color : '#1A1C21', fontWeight : 700}}>S$ {props?.invoiceAmount/100}</Typography>
                            </Box>
                    </Box>
            </Box>

            <Box sx={{mt : 1.5}}>
                <Typography sx={{fontSize : '10px', fontWeight : 500, color : '#5E6470'}}>Terms & Conditions</Typography>
                <Typography sx={{fontSize : '10px', fontWeight : 500, color : '#5E6470'}}>Thanks for purchasing.</Typography>
            </Box>

    </Box>
  )
});

export default PdfGenerate